import IinvsysLogo from '../../../../assets/svg/Logos/IinvsysLogo';
import CommonButtonView from '../../CommonButton/View/CommonButtonView';
import { HeaderController } from '../Controller/HeaderController';
import { ContactusButton, HeaderNavItems, productList, companyList } from '../Model/HeaderModel';
import '../Styles/HeaderStyles.css';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';

const HeaderView = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

    const navigate = useNavigate();
    const {
        NavigateTo,
        handleProductClick,
        handleSolutionsClick,
        handleCompanyClick,
        handleNavigate,
        showProducts,
        setShowProducts,
        showProductsmob,
        setShowProductsmob,
        menuOpen,
        setMenuOpen,
        indexValue,
        setIndex,
        toggleMenu,
        dropdownRef,
        menuRef,
        hamburgerRef,
        productref,
        toggleHamburger,
        isOpen,
        setIsOpen,
        mobileExpandRef,
        bottomHeader,
        showSolutions,
        setShowSolutions,
        showCompany,
        setShowCompany,
        showCompanymob,
        setShowCompanymob,
        companyRef,
    } = HeaderController();
    const [showSolutionsmob, setShowSolutionsmob] = useState(false);
    const mid = Math.ceil(productList.length / 2);
    const leftColumn = productList.slice(0, mid);
    const rightColumn = productList.slice(mid);

    useEffect(() => {
        if (!isMobile) {
            productList.forEach(product => {
                const img = new Image();
                img.src = product.image;
            });
        }
    }, [isMobile]);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1200);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);

    const [scrollBoxTop, setScrollBoxTop] = useState(0);
    const scrollRef = useRef(null);

    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        const handleScroll = () => {
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;
            const maxScrollTop = (scrollHeight - clientHeight);
            const percentScrolled = scrollTop / maxScrollTop;
            const maxBoxMove = clientHeight;
            setScrollBoxTop((percentScrolled * maxBoxMove) + 15);
        };

        container.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, [showProductsmob]);


    const [scrollBoxTopSol, setScrollBoxTopSol] = useState(15);
    const scrollRefSol = useRef(null);

    useEffect(() => {
        const container = scrollRefSol.current;
        if (!container) return;

        const handleScroll = () => {
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;

            const maxScrollTop = (scrollHeight - clientHeight);
            const percentScrolled = scrollTop / maxScrollTop;
            const maxBoxMove = clientHeight;

            setScrollBoxTopSol((percentScrolled * maxBoxMove) + 15);
        };

        container.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, [showSolutionsmob]);
    // 🔹 End Solutions scroll setup

    const [solutionsList] = useState([
        { name: 'IoT/IIoT', link: '/iot' },
        { name: 'Railways', link: '/railways' },
        { name: 'Space', link: '/space' },
    ]);



    const solutionsRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                productref.current &&
                !productref.current.contains(event.target) &&
                solutionsRef.current &&
                !solutionsRef.current.contains(event.target)
            ) {
                setShowProducts(false);
                setShowSolutions(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);



    return (
        <div
            className='header-view-main-container'
            style={{
                zIndex: 10,
                backgroundColor: showProducts ? 'var(--mobile-header-background)' : 'black',
            }}
        >
            <>
                <div className={showProducts ? 'header-blur-effect-1-none' : 'header-blur-effect-1'}></div>
                <div className={showProducts ? 'header-blur-effect-2-none' : 'header-blur-effect-2'}></div>

                <div className='header-view-main-container-wrapup'>
                    {/* Logo */}
                    <div className='header-view-main-logo-container' onClick={() => NavigateTo('/')}>
                        <IinvsysLogo />
                    </div>


                    <div className='header-view-main-main-container'>
                        {HeaderNavItems.map((value, index) => (
                            <div key={index} className="nav-item-wrapper" style={{ position: 'relative' }}>
                                {value.name === 'Products' ? (
                                    <>
                                        <span
                                            className={showProducts ? 'header-link-stylings-active' : 'header-link-stylings'}
                                            onClick={handleProductClick}
                                            ref={productref}
                                        >
                                            {value.name}
                                        </span>

                                        <div
                                            ref={dropdownRef}
                                            className={`product-dropdown ${showProducts ? 'show' : ''}`}
                                        >
                                            <div className='product-dropdown-content-container'>
                                                <div className='product-dropdown-image-container'>
                                                    <img
                                                        src={productList[indexValue]?.image}
                                                        alt=''
                                                        loading="lazy"
                                                        decoding="async"
                                                        draggable="false"
                                                    />
                                                </div>

                                                <div className="product-dropdown-content-scroll-wrapper">
                                                    <div className="product-dropdown-content-product-list-container">
                                                        <div className="product-column">
                                                            {leftColumn.map((product, idx) => (
                                                                <div
                                                                    key={idx}
                                                                    className={
                                                                        idx === indexValue
                                                                            ? 'product-dropdown-content-container-product-name-active-ac'
                                                                            : 'product-dropdown-content-container-product-name'
                                                                    }
                                                                    data-text={product.name}
                                                                    onMouseEnter={() => setIndex(idx)}
                                                                    onMouseDown={() => handleNavigate(product.link)}
                                                                >
                                                                    {product.name}
                                                                </div>
                                                            ))}
                                                        </div>

                                                        <div className="product-column">
                                                            {rightColumn.map((product, idx) => (
                                                                <div
                                                                    key={idx + mid}
                                                                    className="product-dropdown-content-container-product-name"
                                                                    data-text={product.name}
                                                                    onMouseEnter={() => setIndex(idx + mid)}
                                                                    onMouseDown={() => handleNavigate(product.link, idx)}
                                                                >
                                                                    {product.name}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : value.name === 'Solutions' ? (
                                    <div ref={solutionsRef} style={{ position: 'relative' }}>
                                        <span
                                            className={showSolutions ? 'header-link-stylings-active' : 'header-link-stylings'}
                                            onClick={handleSolutionsClick}
                                        >
                                            {value.name}
                                        </span>

                                        {showSolutions && (
                                            <div className="solutions-popup">
                                                <div className="solutions-popup-content">
                                                    {solutionsList.map((domain, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="solution-item"
                                                            onMouseDown={() => {
                                                                setShowSolutions(false);
                                                                NavigateTo(domain.link);
                                                            }}
                                                        >
                                                            {domain.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : value.name === 'Company' ? (
                                    <div ref={companyRef} style={{ position: 'relative' }}>
                                        <span
                                            className={showCompany ? 'header-link-stylings-active' : 'header-link-stylings'}
                                            onClick={handleCompanyClick}
                                        >
                                            {value.name}
                                        </span>

                                        {showCompany && (
                                            <div className="solutions-popup">
                                                <div className="solutions-popup-content">
                                                    {companyList.map((item, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="solution-item"
                                                            onMouseDown={() => {
                                                                setShowCompany(false);
                                                                NavigateTo(item.link);
                                                            }}
                                                        >
                                                            {item.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : value.name === "Contact Us" ? null : (
                                    <span
                                        className='header-link-stylings'
                                        onClick={() => NavigateTo(value.link)}
                                    >
                                        {value.name}
                                    </span>
                                )}
                            </div>
                        ))}
                    </div>


                    <div className='header-view-main-button-container'>
                        <div className='header-view-main-button-container-wrapup'>
                            <CommonButtonView
                                name={ContactusButton.name}
                                Todo={() => NavigateTo(ContactusButton.link)}
                            />
                        </div>
                    </div>
                </div>

                {isMobile &&
                    <div className='mobile-page-bottom-header'>
                        <div className='mobile-page-bottom-header-icon-container' onClick={(e) => { toggleHamburger(e) }}>
                            <div className={`hamburger ${isOpen ? 'open' : ''}`}>
                                <span className="line top"></span>
                                <span className="line middle"></span>
                                <span className="line bottom"></span>
                            </div>
                        </div>
                        <div className='mobile-page-bottom-header-button-container'>
                            <button onClick={() => { toast.dismiss(); toast('Coming Soon') }}>Schedule Demo</button>
                        </div>
                    </div>
                }
            </>

            {/* Mobile Expand */}
            <div ref={mobileExpandRef}
                className={`mobile-page-bottom-header-expand ${isOpen ? 'show' : ''}`}
            >
                {HeaderNavItems.map((value, index) => (
                    <div key={index} className="nav-item-wrapper">
                        {value.name === 'Products' ? (
                            <>
                                <li
                                    className="header-link-stylings-mob"
                                    onClick={() => {
                                        setShowProductsmob(!showProductsmob);
                                        setShowSolutionsmob(false); // close solutions
                                    }}
                                >
                                    {value.name}
                                </li>

                                {showProductsmob && (
                                    <div className="mobile-product-submenu">
                                        <div
                                            className="scroll-indicator-box"
                                            style={{ top: `${scrollBoxTop}px` }}
                                        ></div>

                                        <div className="mobile-product-submenu-width-maintain" ref={scrollRef}>
                                            {productList.map((product, idx) => (
                                                <div
                                                    key={idx}
                                                    className="mobile-product-submenu-item"
                                                    onClick={() => {
                                                        window.scrollTo(0, 0);
                                                        navigate(product.link);
                                                        setIsOpen(false);
                                                        setMenuOpen(false);
                                                    }}
                                                >
                                                    {product.name}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : value.name === 'Solutions' ? (
                            <>
                                <li
                                    className="header-link-stylings-mob"
                                    onClick={() => {
                                        setShowSolutionsmob(!showSolutionsmob);
                                        setShowProductsmob(false); // close products
                                    }}
                                >
                                    {value.name}
                                </li>

                                {showSolutionsmob && (
                                    <div className="mobile-product-submenu">
                                        <div
                                            className="scroll-indicator-box-solution"
                                            style={{ top: `${scrollBoxTopSol}px` }}
                                        ></div>

                                        <div className="mobile-product-submenu-width-maintain-solutions" ref={scrollRefSol}>
                                            {solutionsList.map((solution, idx) => (
                                                <div
                                                    key={idx}
                                                    className="mobile-product-submenu-item"
                                                    onClick={() => {
                                                        window.scrollTo(0, 0);
                                                        navigate(solution.link);
                                                        setIsOpen(false);
                                                        setMenuOpen(false);
                                                    }}
                                                >
                                                    {solution.name}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : value.name === 'Company' ? (
                            <>
                                <li
                                    className="header-link-stylings-mob"
                                    onClick={() => {
                                        setShowCompanymob(!showCompanymob);
                                        setShowProductsmob(false);
                                        setShowSolutionsmob(false);
                                    }}
                                >
                                    {value.name}
                                </li>

                                {showCompanymob && (
                                    <div className="mobile-product-submenu">
                                        <div className="mobile-product-submenu-width-maintain-solutions">
                                            {companyList.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className="mobile-product-submenu-item"
                                                    onClick={() => {
                                                        window.scrollTo(0, 0);
                                                        navigate(item.link);
                                                        setIsOpen(false);
                                                        setMenuOpen(false);
                                                    }}
                                                >
                                                    {item.name}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <li
                                className="header-link-stylings-mob"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                    navigate(value.link);
                                    setIsOpen(false);
                                    setMenuOpen(false);
                                }}
                            >
                                {value.name}
                            </li>
                        )}
                    </div>
                ))}

                {/* <li
                    className="header-link-stylings-mob"
                    style={{ padding: '5px' }}
                    onClick={() => {
                        window.scrollTo(0, 0);
                        navigate('/support');
                        setIsOpen(false);
                        setMenuOpen(false);
                    }}
                >
                    Contact Us
                </li> */}
            </div>
        </div>
    );
};

export default HeaderView;
